import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Checkbox from '@/src/components/common/Checkbox/Checkbox';
import { RootState } from '@/src/reducers/types';

import DeleteMultiple from '../Body/Actions/Delete/DeleteMultiple';
import Download from '../Body/Actions/Download/Download';
import Move from '../Body/Actions/Move/Move';
import { Restore } from '../Body/Actions/Restore/Restore';

const MultipleActions = () => {
  const dispatch = useDispatch();
  const files = useSelector((state: RootState) => state.files);
  const inTrash = files.activeInSidebar.id === 'trash';

  const handleUnselectAll = () => {
    dispatch({
      type: 'UPDATE_FILES_LIST',
      list: files.list.map((f) => ({ ...f, isSelected: false })),
    });
  };

  const itemIds = files?.selectedItems.map((f) => f.id) || [];
  const itemIdsVersioned =
    files?.selectedItems.map((f) => ({ id: f.id, version: f.version })) || [];

  if (files.selectedItems.length > 0) {
    return (
      <div className="filesSelectedAll">
        <div
          className={`selectedCount ${
            Boolean(files.selectedItems.length) && files.selectedItems.length > 0
              ? ''
              : 'notSelectedAll'
          }`}
        >
          <Checkbox checked={true} onChange={handleUnselectAll} />
          <span>
            {files.selectedItems.length} {files.selectedItems.length === 1 ? 'item' : 'items'}{' '}
            selected
          </span>
        </div>
        {!inTrash ? (
          <div className="selectedActions">
            <>
              <div className="actionItem">
                <Move itemIdsVersioned={itemIdsVersioned} />
              </div>
              <div className="actionItem">
                <Download itemIds={itemIds} />
              </div>
              <div className="actionItem">
                <DeleteMultiple itemIdsVersioned={itemIdsVersioned} inTrash={inTrash} />
              </div>
            </>
          </div>
        ) : (
          <div className="selectedActions">
            <div className="actionItem">
              <Restore itemIdsVersioned={itemIdsVersioned} />
            </div>
            <div className="actionItem">
              <DeleteMultiple itemIdsVersioned={itemIdsVersioned} inTrash={inTrash} />
            </div>
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default MultipleActions;
